import "intl-tel-input/build/css/intlTelInput.min.css";
import intlTelInput from "intl-tel-input";
import intlTelInputUtils from "intl-tel-input/build/js/utils";
import axios from 'axios';
import { AppConfig } from "@/config/index";

export const getCountryAlpha2 = () => {
    return axios(`${AppConfig.apiUrl}/api/country`).then(res => (res.data || {}).code || 'US').catch(() => 'US')
}

export const useIntlTelInput = ({ telInput }) => {
    const iti = intlTelInput(telInput, {
        initialCountry: "auto",
        separateDialCode: true,
        geoIpLookup: async function (success, failure) {
            success(await getCountryAlpha2() || '')
        },
        utilsScript: intlTelInputUtils
    });

    const validationError = {
        "IS_POSSIBLE": 0,
        "INVALID_COUNTRY_CODE": 1,
        "TOO_SHORT": 2,
        "TOO_LONG": 3,
        "NOT_A_NUMBER": 4
    };

    const errors = {
        [validationError.IS_POSSIBLE]: '',
        [validationError.INVALID_COUNTRY_CODE]: 'Invalid country code.',
        [validationError.TOO_SHORT]: 'The number is to short.',
        [validationError.TOO_LONG]: 'The number is to long.',
        [validationError.NOT_A_NUMBER]: 'Please input a valid number.'
    }

    const savePhone = ({ phoneNumber }) => {
        return API_Service.setPhoneNumber({ phoneNumber })
    }

    const validate = () => {
        const error = iti.getValidationError()
        return errors[error]
    }

    return {
        iti,
        validate,
        savePhone
    }
}
